import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { FxFooter } from "./FxFooter";
import { FxLabel, FxLabelBase } from "./FxLabel";
import { FxTextFieldBase } from "./FxTextField";
import { FxCheckBoxBase } from "./FxCheckBox";
import { FxButtonBase } from "./FxButton";

import { FxSelectComplex, FxSelectCompany, FxSelectPlant, FxSelectEnergy, FxSelectFacility, FxSelectPipe } from "../../vup/inputs/VupInputs";
import { FxDataGridBase } from "../components/grid/FxDataGrid";

/**
 * 
 * @param {List} cols 컬럼 크기 정의
 * @param {List} rows 테이블 내용 정의
 * @param {object} style 
 * @returns 
 */
export const FxForm = (props) => {
  const { cols, rows, style } = props;

  return (
    <div key="FxDataEdit" className="FxDataEdit" style={style ? style : {}}>
      <table key="FxDataEditTable" className="FxDataEditTable">
        <colgroup>
          {cols.map((x, index) => {
            return <col style={{ width: x }} />;
          })}
        </colgroup>
        {rows.map((x, index) => {
          return <tr style={x.css ? x.css : {}} >
            {x.inputs.map((x1, index1) => {
              const type = typeof x1;
              let colspan;
              try {
                colspan = x.colspan[index1];
              } catch (error) {
                colspan = 1;
              }

              if (type === 'string') {
                return <th colSpan={colspan}>
                  <FxLabelBase>{x1}</FxLabelBase>
                </th>;
              } else if (type === 'number') {
                return <td colSpan={colspan}></td>;
              } else {
                return <td colSpan={colspan}>
                  {x1}
                </td>
              }
            })}
          </tr>
        })}
      </table>
    </div>
  );
};

export const FxFormSample = (props) => {
  const { isLoaded } = props;

  const [inputDatas, setInputDatas] = React.useState({});
  const [complexInloNo, setComplexInloNo] = React.useState(0);
  const [companyInloNo, setCompanyInloNo] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [index, setIndex] = React.useState(10);
  const [selectedRow, setSelectedRow] = React.useState(null);

  function onChangeValue(id, value) {
    let newData = { ...inputDatas };
    if (value) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputDatas(newData);

    if (id == "complexInloNo") {
      setComplexInloNo(value);
    } else if (id == "companyInloNo") {
      setCompanyInloNo(value);
    }
  }

  function onCellSelected(row) {
    setSelectedRow(row);
  }
  function onClick(name) {
    if (name == 'btnAdd') {
      let tmpRows = [...rows];
      let n = index + 1;
      tmpRows.push({ va1: "text-" + n, id: n });
      setRows(tmpRows);
      setIndex(n);
    } else if (name == 'btnRemove') {
      let tmpRows = [...rows];
      for (let i = 0; i < tmpRows.length; i++) {
        if (tmpRows[i].id == selectedRow.id) {
          tmpRows.splice(i, 1);
          break;
        }
      }
      if (tmpRows.length != rows.length) {
        setRows(tmpRows);
      }
    } else if (name == "click") {
      console.log("aaaaaaaaaaaaaaaa", inputDatas, rows);
    }
  }

  useEffect(() => {

    let tmpRows = [];
    for (let i = 0; i < index; i++) {
      tmpRows.push({ va1: "text" + i, id: i });
    }
    setRows(tmpRows)

  }, []);

  let cols = [];
  cols.push({
    field: "va1",
    headerName: "1번선수",
    width: 200,
    headerClassName: "DataGridHeader",
    editable: false,
    type: "string",
  }
  );
  cols.push({
    field: "va2",
    headerName: "2번선수",
    width: 200,
    headerClassName: "DataGridHeader",
    editable: false,
    type: "string",
  }
  );


  if (isLoaded == false) {
    return <></>
  }


  return (
    <>
      <FxForm style={{ width: '600px', borderColor: 'green' }}
        cols={['10%', '30%', '30%', '10%', '10%', '*']}
        rows={[
          {
            inputs: ["산단조회"
              , <FxSelectComplex onChangeValue={onChangeValue} width="300px" name="test1" optionText="산단을 선택하세요" />]
            , colspan: [1, 5]
          }
          , {
            inputs: ["산단"
              , <FxSelectComplex onChangeValue={onChangeValue} width="300px" />
              , "회사"
              , <FxSelectCompany onChangeValue={onChangeValue} width="300px" complexInloNo={complexInloNo} />]
            , colspan: [1, 2, 1, 2]
          }

          , {
            inputs: ["공장", <FxSelectPlant onChangeValue={onChangeValue} width="300px" companyInloNo={companyInloNo} />]
            , colspan: [1, 5]
          }
          , {
            inputs: ["에너지", <FxSelectEnergy onChangeValue={onChangeValue} width="300px" />]
            , colspan: [1, 5]
          }
          , {
            inputs: ["설비", <FxSelectFacility onChangeValue={onChangeValue} width="300px" complexInloNo={complexInloNo} />]
            , colspan: [1, 5]
          }
          , {
            inputs: ["배관"
              , <FxSelectPipe onChangeValue={onChangeValue} width="300px" complexInloNo={complexInloNo} />
              , <FxButtonBase name="btnAdd" onClick={onClick} text="추가" className="FxButtonSearch" />
              , <FxButtonBase name="btnRemove" onClick={onClick} text="제거" />]
            , colspan: [1, 3, 1, 1]
          }
          , {
            inputs: ["자료", <FxDataGridBase columns={cols} rows={rows} height="300px" onCellSelected={onCellSelected} />]
            , colspan: [1, 5]
            , css: { height: "300px" }
          }
          , {
            inputs: ["메모"
              , <FxTextFieldBase name="memo" onChangeValue={onChangeValue} width="100%" />]
            , colspan: [1, 5]
            , css: { height: "100px" }
          }
          , {
            inputs: [<FxButtonBase name="click" onClick={onClick} text="기록" />]
            , colspan: [6]
          }
        ]
        }
      >
      </FxForm>
    </>
  );
};

/**
 * 
 * @param {List} left 왼쪽에 넣을 버튼
 * @param {List} right 오른쪽에 넣을 버튼
 * @returns 
 */
export const FxFormButtons = (props) => {

  const { left, right, center } = props;

  return (
    <div className="FxCrudToolbar">
      <div className="FxFilterLeft">
        {left}
      </div>
      <div className="FxFilterRight">
        {right}
      </div>
      <div className="FxFilterCenter">
        {center}
      </div>
    </div>
  );
}